import React from 'react';
import { FooterLinksComponentProps } from '../../constants/interface';
import { useTranslation } from 'react-i18next';
import { useCustomNavigation } from '../../utility/Utility.ts';

const FooterLinksComponent = (props: FooterLinksComponentProps) => {
    const { title, links, } = props;
    const {t} = useTranslation();
    const customNavigate = useCustomNavigation();

    return (
        <div className="grid gap-3 lg:gap-6">
            <p className="text-base font-bold lg:font-semibold">{t(title)}</p>
            <div className="grid gap-2 lg:gap-4">
                {
                    links.map((item, index: number) => (
                        <div key={index} className={`flex gap-3 items-center max-w-60 w-fit ${(item.link) ? 'cursor-pointer hover:underline' : ''}`}
                            onClick={() => customNavigate((item.isRouterLink || false) , item.link) }
                            >
                            <>
                                {
                                    (item.img) &&
                                    <img loading="lazy" src={item.img} alt={t(item.title)} />
                                }
                            </>
                            <p className="text-sm font-normal">{t(item.title)}</p>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

export default FooterLinksComponent;